import { ReactNode } from 'react'
import { CheckIcon } from '@heroicons/react/24/outline'

type ChipProps = {
  children: ReactNode
  selected: boolean
  classes?: string
  onClick?: () => void
}

export function Chip({
  children,
  selected = false,
  classes,
  onClick
}: ChipProps) {
  let allClasses = `${
    classes ?? ''
  } inline-flex items-center border font-medium text-sm rounded-full shadow-sm px-4 py-1.5 border-gray-300`

  if (selected) {
    allClasses += ' bg-blue-500 hover:bg-blue-600 text-white'
  } else {
    allClasses += ' bg-gray-300 text-gray-700 hover:bg-gray-400'
  }

  return (
    <button type="button" className={allClasses} onClick={onClick}>
      {selected && <CheckIcon className="mr-1 h-4 w-4" />}
      {children}
    </button>
  )
}
